import React from 'react';
import BLComponent from '../../core/_BLComponent.jsx';

export default class CategoryFilterHeader extends BLComponent {
    constructor(props, context) {
        super(props, context);	// This should come first. 
    }
   
    render() {
        const {selectedCategory} = this.props.data;
        const selectedCategoryView = selectedCategory.map((category, idx) => {
            const catName = blapp.util.decodeHtml(category.catName);
            return(
                <div key={"selectedCategoryView" + idx} className="personal-inventory__category-filter-tag-item text--small">
                    {catName} ({category.itemCnt}) <button className="l-margin-left--sm btn btn--blank" onClick={() => this.props.func.toggleCategory(category.idCategory, true)}><i className="fa-solid fa-circle-xmark"/></button>
                </div>
            )
        });
        return (
            <div className="l-margin-y--xl l-flex l-flex-wrap personal-inventory__category-filter-tag">
                {selectedCategoryView} {(selectedCategory.length > 1)&&<div><button className="btn btn--link text--small" onClick={()=>this.props.func.clearCategoryFilter()}>Clear filters</button></div>}
            </div>
        );
    }
}
